'use client'

import {
  faCircleCheck,
  faCircleXmark,
  faPeriod,
} from '@fortawesome/pro-solid-svg-icons'
import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export type ProsAndConsContent = {
  summary?: string
  pros: Array<string>
  cons: Array<string>
}

type Props = {
  content: ProsAndConsContent
}

export default function ProsAndConsBlock({ content }: Props) {
  return (
    <div className="grid grid-cols-1 divide-y divide-[#ECECEF] rounded-[20px] border border-[#ECECEF] bg-[#F8F8F9] px-6 py-1.5 lg:rounded-[24px] lg:px-8">
      {content.summary && (
        <div className="py-4">
          <p className="text-[16.5px] font-medium leading-[25px] text-[#46464E]">
            {content.summary}
          </p>
        </div>
      )}
      <div className="grid grid-cols-1 gap-y-5 divide-[#ECECEF] py-4 sm:grid-cols-2 sm:divide-x sm:py-6">
        <div>
          <div className="flex items-center gap-x-2">
            <FontAwesomeIcon
              icon={faCircleCheck}
              className="text-[#1F8A70]"
              size="xl"
            />
            <h4 className="text-lg font-bold text-[#0B0B0F]">Pros</h4>
          </div>
          <ul className="mt-2.5 flex flex-col gap-y-1.5 sm:pr-6">
            {content.pros.map((pro) => (
              <li key={pro}>
                <p>
                  <FontAwesomeIcon
                    icon={faPeriod}
                    className="ml-2 mr-3 -translate-y-1/3 text-[#43BBA9]"
                    size="lg"
                  />
                  <span className="text-[15px] leading-[23px] text-[#46464E]">
                    {pro}
                  </span>
                </p>
              </li>
            ))}
          </ul>
        </div>
        <div className="sm:pl-6">
          <div className="flex items-center gap-x-2.5">
            <FontAwesomeIcon
              icon={faCircleXmark}
              className="text-[#9B5460]"
              size="xl"
            />
            <h4 className="text-lg font-bold text-[#0B0B0F]">Cons</h4>
          </div>
          <ul className="mt-2.5 flex flex-col gap-y-1.5">
            {content.cons.map((con) => (
              <li key={con}>
                <p>
                  <FontAwesomeIcon
                    icon={faPeriod}
                    className="ml-2 mr-3 -translate-y-1/3 text-[#C9808A]"
                    size="lg"
                  />
                  <span className="text-[15px] leading-[23px] text-[#46464E]">
                    {con}
                  </span>
                </p>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  )
}
